var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "ml-3 mb-2",
              attrs: { "x-small": "", color: "accent", disabled: _vm.readOnly },
              on: { click: _vm.makeEverythingCorrect }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("thumb_up_alt")]),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("EverythingIsCorrect")) + "\n    "
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticStyle: { width: "100%" }, attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs7: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "input-field",
                  staticStyle: { width: "100%", "text-transform": "uppercase" }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("Environment")) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    value: _vm.objectData.environment,
                    label: "",
                    "input-type": "other",
                    size: "large",
                    "field-disabled": _vm.readOnly
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_implanted_in_private_property"
                          ),
                          label: _vm.$t("ImplantedPrivateProperty"),
                          disabled: _vm.readOnly,
                          color: "accent",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_implanted_in_private_property",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_problematic_overhang"
                          ),
                          label: _vm.$t("ProblematicOverhang"),
                          disabled: _vm.readOnly,
                          color: "accent",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_problematic_overhang",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_pruning_required"
                          ),
                          label: _vm.$t("PruningRequired"),
                          disabled: _vm.readOnly,
                          color: "accent",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_pruning_required",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_installed_bitumen_tarmac_cobblestone"
                          ),
                          label: _vm.$t("InstalledBitumenTarmacCobblestone"),
                          disabled: _vm.readOnly,
                          color: "accent",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_installed_bitumen_tarmac_cobblestone",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_accessible_with_vehicle"
                          ),
                          label: _vm.$t("AccessibleWithVehicle"),
                          disabled: _vm.readOnly,
                          color: "#4fa2b7",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_accessible_with_vehicle",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs5: "" } },
            [
              _c("photo-field", {
                attrs: {
                  disabled: _vm.disabled,
                  "image-data": _vm.environmentPhoto,
                  previousPhoto: _vm.getPhoto(_vm.environmentPhoto.varName)
                },
                on: {
                  updatePhoto: function($event) {
                    return _vm.updatePhoto($event)
                  },
                  removePhoto: function($event) {
                    return _vm.removePhoto($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticStyle: { width: "100%" }, attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs7: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "input-field",
                  staticStyle: { width: "100%", "text-transform": "uppercase" }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Safety")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    value: _vm.objectData.safety,
                    label: "",
                    "input-type": "other",
                    size: "large",
                    "field-disabled": _vm.readOnly
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_buckling_control_ok"
                          ),
                          label: _vm.$t("BucklingControlOK"),
                          disabled: _vm.readOnly,
                          color: "#4fa2b7",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_buckling_control_ok",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_vertical_control_ok"
                          ),
                          label: _vm.$t("VerticalityControlOK"),
                          disabled: _vm.readOnly,
                          color: "#4fa2b7",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(
                              "tp_pe_vertical_control_ok",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_respects_neighboring_light_fixture"
                              ),
                              label: _vm.$t("RespectsNeighboringLightFixture"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_respects_neighboring_light_fixture",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_yellow_label_absent"
                              ),
                              label: _vm.$t("YellowLabelAbsent"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_yellow_label_absent",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_usable_pole_head"
                              ),
                              label: _vm.$t("UsablePoleHead"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_usable_pole_head",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs5: "" } },
            [
              _c("photo-field", {
                attrs: {
                  disabled: _vm.disabled,
                  "image-data": _vm.safetyPhoto,
                  previousPhoto: _vm.getPhoto(_vm.safetyPhoto.varName)
                },
                on: {
                  updatePhoto: function($event) {
                    return _vm.updatePhoto($event)
                  },
                  removePhoto: function($event) {
                    return _vm.removePhoto($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticStyle: { width: "100%" }, attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "input-field",
                  staticStyle: { width: "100%", "text-transform": "uppercase" }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tc("TestNoun", 2)) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    value: _vm.objectData.tests,
                    label: "",
                    "input-type": "other",
                    size: "large",
                    "field-disabled": _vm.readOnly
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValueInObject(
                            "tp_pe_visual_ok"
                          ),
                          label: _vm.$t("Visual") + " OK",
                          disabled: _vm.readOnly,
                          color: "#4fa2b7",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue("tp_pe_visual_ok", $event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_percussion_ok"
                              ),
                              label: _vm.$t("Percussion") + " OK",
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_percussion_ok",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_shake_ok"
                              ),
                              label: _vm.$t("Shake") + " OK",
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue("tp_pe_shake_ok", $event)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTelecom
                        ? _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_square_tip_ok"
                              ),
                              label: _vm.$t("SquareTip") + " OK",
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_square_tip_ok",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isTelecom
            ? _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "input-field",
                      staticStyle: {
                        width: "100%",
                        "text-transform": "uppercase"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$tc("Pole", 1)) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "input-field",
                    {
                      attrs: {
                        value: _vm.objectData.pole,
                        label: "",
                        "input-type": "other",
                        size: "large",
                        "field-disabled": _vm.readOnly
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_pole_head_refitting"
                              ),
                              label: _vm.$t("PoleHeadRefitting"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_pole_head_refitting",
                                  $event
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_pole_recalibration_relocation"
                              ),
                              label: _vm.$t("PoleRecalibrationRelocation"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_pole_recalibration_relocation",
                                  $event
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getValueInObject(
                                "tp_pe_pole_replacement"
                              ),
                              label: _vm.$t("PoleReplacement"),
                              disabled: _vm.readOnly,
                              color: "#4fa2b7",
                              ripple: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateValue(
                                  "tp_pe_pole_replacement",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isTelecom
        ? _c("input-field", {
            attrs: {
              value: _vm.getValueInObject("tp_pe_detail_works_to_perform"),
              label: _vm.$t("DetailWorksToPerform"),
              size: "large",
              inputType: "textarea",
              fieldDisabled: _vm.readOnly
            },
            on: {
              input: function($event) {
                return _vm.updateValue("tp_pe_detail_works_to_perform", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1df2e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1df2e50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/PoleEffortModule/TerrainTab.vue
// module id = null
// module chunks = 